<template>
  <div class="login-container">
    <el-card class="login-card" shadow="hover">
      <h2 class="login-title">Login</h2>
      <el-form @submit.prevent="handleLogin">
        <el-form-item>
          <el-input
            v-model="username"
            placeholder="Username"
            prefix-icon="el-icon-user"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="password"
            type="password"
            placeholder="Password"
            prefix-icon="el-icon-lock"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleLogin" block>Login</el-button>
        </el-form-item>
      </el-form>
      <p v-if="message" class="error-message">{{ message }}</p>
      <router-link :to="`/reset/password/ecp/`" class="username-link">
        Сбросить пароль
      </router-link>
    </el-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { ElMessage } from "element-plus";
import { useRouter } from "vue-router";
import authService from "../services/authService";
import { AuthRequest } from "@/types/auth";

export default defineComponent({
  name: "LoginView",
  setup() {
    const username = ref("");
    const password = ref("");
    const message = ref("");
    const router = useRouter();

    const handleLogin = async () => {
      const requestData: AuthRequest = {
        username: username.value,
        password: password.value,
      };
      try {
        const response = await authService.login(requestData);
        if (response.access_token) {
          const username = localStorage.getItem("username");
          ElMessage.success(`Welcome, ${username}!`);
          await router.push("/");
        } else {
          router.push('/access-denied');
          // message.value = "Invalid login credentials.";
        }
      } catch (error) {
        message.value = "Login failed. Please try again.";
        ElMessage.error(message.value);
      }
    };

    return {
      username,
      password,
      message,
      handleLogin,
    };
  },
});
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-color: #f5f7fa;
}

.login-card {
  width: 400px;
  padding: 30px;
}

.login-title {
  text-align: center;
  margin-bottom: 20px;
}

.error-message {
  color: red;
  margin-top: 15px;
  text-align: center;
}
</style>
